export const VNORDERS_SET_PROMO_CODES = 'VNORDERS_SET_PROMO_CODES'
export const VNORDERS_SET_LAST_PROMO_CODE = 'VNORDERS_SET_LAST_PROMO_CODE'
export const VNORDERS_SET_STAND_AVAILABILITY = 'VNORDERS_SET_STAND_AVAILABILITY'
export const VNORDERS_SET_ORDER = 'VNORDERS_SET_ORDER'
export const VNORDERS_SEND_ORDER_DETAILS_TO_SDK_ANALYTICS = 'VNORDERS_SEND_ORDER_DETAILS_TO_SDK_ANALYTICS'
